module.exports = __webpack_public_path__ + "img/import-manually.cb09ae3.svg";